import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sentimentSelect"]
  static values = { tweetId: Number, clTwKeywordId: Number, memoUrl: String }

  connect() {
    this.modal = document.getElementById('memo-modal')
  }

  get modalController() {
    if (this.modal) {
      return this.application.getControllerForElementAndIdentifier(
        this.modal, 
        'sentiment-memo-modal'
      )
    }
    return null
  }

  updateSentiment(event) {
    const sentimentValue = event.target.value
    
    const formData = new FormData()
    formData.append('tweet_id', this.tweetIdValue)
    formData.append('cl_tw_keyword_id', this.clTwKeywordIdValue)
    formData.append('client_negaposi', sentimentValue)

    fetch(this.memoUrlValue, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 'ok') {
        this.showNotification('感情メモを更新しました', 'success')
      } else {
        this.showNotification('感情メモの更新に失敗しました', 'error')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      this.showNotification('感情メモの更新に失敗しました', 'error')
    })
  }

  showMemoModal(event) {
    event.preventDefault()
    
    // 現在のメモ内容を取得
    const memoCell = event.target.closest('td')
    const memoSpan = memoCell.querySelector('span[title]')
    const currentMemo = memoSpan ? memoSpan.getAttribute('title') || '' : ''
    
    // モーダル内のテキストエリアに現在のメモを設定
    const modal = document.getElementById('memo-modal')
    const textarea = modal.querySelector('textarea')
    if (textarea) {
      textarea.value = currentMemo || ''
    }
    
    // モーダルにデータを設定
    modal.dataset.currentMemoUrl = this.memoUrlValue
    modal.dataset.currentTweetId = this.tweetIdValue
    modal.dataset.currentClTwKeywordId = this.clTwKeywordIdValue
    modal.dataset.currentRowElement = this.element.id || this.element.dataset.rowId || Date.now()
    
    // 行にIDを設定（後で参照用）
    if (!this.element.id) {
      this.element.id = `tweet-row-${Date.now()}`
    }
    modal.dataset.currentRowId = this.element.id
    
    // モーダルを表示 (DaisyUI方式)
    if (modal) {
      // DaisyUIのモーダル表示: modal-openクラスを追加
      modal.classList.add('modal-open')
      // body要素にもmodal-openクラスを追加（背景スクロール防止）
      document.body.classList.add('modal-open')
    }
  }


  showNotification(message, type) {
    // DaisyUI toast風の通知を表示
    const toast = document.createElement('div')
    toast.className = `alert alert-${type === 'success' ? 'success' : 'error'} fixed top-4 right-4 w-auto z-50 shadow-lg`
    toast.innerHTML = `
      <span class="iconify ${type === 'success' ? 'lucide--check-circle' : 'lucide--x-circle'} size-4"></span>
      <span>${message}</span>
    `
    
    document.body.appendChild(toast)
    
    // 3秒後に削除
    setTimeout(() => {
      toast.remove()
    }, 3000)
  }
}